import {
  FilterMode,
  ShowcaseCategoryCreateMutationVariables,
  ShowcaseCategory_OrderBy,
  ShowcaseCategory,
  SortOrder,
  ShowcaseCategory_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const showcaseCategoryService = {
  createOne: buildCreateOne(
    (
        showcaseCategoryCreateVariables: ShowcaseCategoryCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.showcaseCategoryCreate(
          showcaseCategoryCreateVariables
        );
        return result.showcaseCategoryCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.showcaseCategoryOne({ id });
    return result.showcaseCategoryOne as ShowcaseCategory;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: ShowcaseCategory_OrderBy[] | null = null,
    filter: ShowcaseCategory_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: ShowcaseCategory_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.showcaseCategoryListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.showcaseCategoryListWithOffset
    ) as ShowcaseCategory[];
    return { list, orderBy };
  },
};
